"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AI_SESSION_FEEDBACK_REASON_MAX_RATING = exports.AI_SESSION_FEEDBACK_REASONS = void 0;
exports.AI_SESSION_FEEDBACK_REASONS = [
    "wrong_information",
    "did_not_understand",
    "cannot_do_what_i_need",
    "wanted_a_person",
    "too_slow",
];
exports.AI_SESSION_FEEDBACK_REASON_MAX_RATING = 3;
